export default "__VITE_ASSET__CTlj$$gJ__"